/**
 * Algolia index name for the marketing search modal. Must match `initIndex` in
 * `serverless/functions/indexer/clients/algolia.js` given Netlify `INDEXER_*` / `ALGOLIA_*` env.
 * See `serverless/functions/indexer/README.md` (section **Algolia index names vs marketing search**).
 *
 * @param {string} searchEnvironment - Typically `metadata.searchEnvironment` / `ALGOLIA_SEARCH_ENVIRONMENT`.
 * @param {string} htmlLang - `document.documentElement.lang` (e.g. `en-US`, `en-GB`).
 * @return {string}
 */
function getAlgoliaMarketingSearchIndexName(searchEnvironment, htmlLang) {
  const env = (searchEnvironment || 'production').toLowerCase();
  const lang = htmlLang || 'en-US';
  const useQaIndex = ['development', 'qa', 'staging'].includes(env);
  if (useQaIndex) {
    return `public-qa-${lang}`;
  }
  return `public-${lang}`;
}

module.exports = getAlgoliaMarketingSearchIndexName;
